// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import Vue from 'vue'
import App from './App'
import router from './router'
// import MetaInfo from 'vue-meta-info'
// import ELEMENT from 'element-ui'
// import 'element-ui/lib/theme-chalk/index.css'
// import Vuex from 'vuex'
import store from './store/store.js'
// import axios from 'axios'
import notify from './utils/notify.js'
import COOKIE from './utils/cookie.js'
import BASE64 from './utils/jbase64.js'
import common from './utils/common.js'
import axiosConfig from './config/axiosConfig.js'
import 'babel-polyfill'

import './assets/style/app.styl'

// Vue.use(MetaInfo)

// Vue.use(Vuex);
// Vue.use(ELEMENT, { size: 'small' });
Vue.prototype.$ELEMENT = ({ size: 'small' });
Vue.config.productionTip = false



import leftNav from '@/components/index/leftNav'

Vue.component('leftNav', leftNav)
/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

export default vue



// WEBPACK FOOTER //
// ./src/main.js